module.exports = __webpack_public_path__ + "img/chivas-crystalgold-first.1bab03ae.png";